import { render, staticRenderFns } from "./commonFrasF.vue?vue&type=template&id=663d9f4d"
import script from "./commonFrasF.vue?vue&type=script&lang=js"
export * from "./commonFrasF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports